var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nut-avatar",style:(_vm.styles),on:{"click":_vm.activeAvatar}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.bgImage}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }